/**
 * Format date key in local timezone to avoid UTC day shifts.
 */
export function formatLocalDateKey(date) {
  if (!(date instanceof Date) || Number.isNaN(date.getTime())) return '';
  const y = date.getFullYear();
  const m = String(date.getMonth() + 1).padStart(2, '0');
  const d = String(date.getDate()).padStart(2, '0');
  return `${y}-${m}-${d}`;
}

/**
 * Generate month days array aligned to Monday-first week header.
 * Returns array of Date/null placeholders.
 */
export function getMonthCalendarDays(viewDate) {
  const year = viewDate.getFullYear();
  const month = viewDate.getMonth();
  const firstDay = new Date(year, month, 1);
  const lastDay = new Date(year, month + 1, 0);
  const daysInMonth = lastDay.getDate();

  // Convert JS day (Sun=0..Sat=6) to Mon-first index (Mon=0..Sun=6)
  const mondayFirstOffset = (firstDay.getDay() + 6) % 7;

  const days = [];
  for (let i = 0; i < mondayFirstOffset; i++) days.push(null);
  for (let day = 1; day <= daysInMonth; day++) {
    days.push(new Date(year, month, day));
  }
  return days;
}

export function startOfLocalToday() {
  const now = new Date();
  now.setHours(0, 0, 0, 0);
  return now;
}
